import { useId } from "react";


export function Input(props: React.ComponentProps<"input"> & { readonly label?: string; }) {
	const id = useId();

	return (
		<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
			{props.label != null && (
				<label className="labelsForm" htmlFor={id}>{props.label}</label>
			)}
			<input
				className="inputsForm"
				id={id}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...props}
			/>
		</div>
	);
}

export function TextArea(props: React.ComponentProps<"textarea"> & { readonly label?: string; }) {
	const id = useId();

	return (
		<div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
			{props.label != null && (
				<label className="labelsForm" htmlFor={id}>{props.label}</label>
			)}
			<textarea
				className="inputsForm"
				id={id}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...props}
			/>
		</div>
	);
}